import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProjectSectionHeader = ({
  setDeleteType,
  breadCrumbText,
  title,
  reloadList,
  projectid,
  isProjectModerator,
  projectMemberStatus,
  projectModStatus,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            bottom={true}
            displayName={`${title}`}
          />
        </div>
        {isProjectModerator ||
        (projectMemberStatus === "1" && projectModStatus === "1") ? (
          <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
            <Link
              onClick={reloadList}
              to="#"
              className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
              title={t("Reload")}
            >
              <span className="material-symbols-outlined icon-md me-1">
                refresh
              </span>
              <span className="fw-semibold small">{t("Reload")}</span>
            </Link>

            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("Section View")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/tasksection/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      list
                    </span>
                    <span className="d-block">{t("Section View")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/tasklist/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      list
                    </span>
                    <span className="d-block">{t("List View")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/kanban/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      view_kanban
                    </span>
                    <span className="d-block">{t("Kanban View")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/gantt/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      insert_chart_outlined
                    </span>
                    <span className="d-block">{t("Gantt View")}</span>
                  </Link>
                </li>
              </ul>
            </div>

            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("Action")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#addFollowers"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      person
                    </span>
                    <span className="d-block">{t("Add Followers")}</span>
                  </Link>
                </li>
                {/* --- add label start --- */}
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    data-bs-toggle="modal"
                    data-bs-target="#addLabelModal"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      label
                    </span>
                    <span className="d-block">{t("Add Label")}</span>
                  </Link>
                </li>
                {/* --- add label start --- */}
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#createAlertModal"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      alarm
                    </span>
                    <span className="d-block">{t("Create alert")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    data-bs-toggle="modal"
                    data-bs-target="#addAssingTask"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      task
                    </span>
                    <span className="d-block">{t("Assign Tasks")}</span>
                  </Link>
                </li>

                {/* <!-- ========== Start delete task Section ========== --> */}
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    data-bs-toggle="modal"
                    data-bs-target="#projectTaskDeleteModal"
                    onClick={() => {
                      setDeleteType("bulk");
                    }}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      delete
                    </span>
                    <span className="d-block">{t("Delete Tasks")}</span>
                  </Link>
                </li>
                {/* <!-- ========== End delete task Section ========== --> */}
              </ul>
            </div>

            <Link
              to="#"
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
              type="button"
              data-bs-toggle="offcanvas"
              // data-bs-target="#offcanvasTaskFilter"
              data-bs-target="#taskAdvanceFilter"
              aria-controls="taskAdvanceFilter"
            >
              <span className="material-symbols-outlined icon-md me-1">
                tune
              </span>
              <span className="fw-semibold small">{t("Filter")}</span>
            </Link>
            {isProjectModerator && (
              <Link
                to="#"
                className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
                data-bs-toggle="modal"
                data-bs-target="#addSectionModal"
              >
                <span className="material-symbols-outlined icon-md">add</span>
                <span>{t("Add Section")}</span>
              </Link>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProjectSectionHeader;
